<template>
    <div>
        <div>
            <div class="d-flex justify-space-between mb-4">
                <div>
                    <div class="page-title mb-2">ระบบประเมินระดับเทคโนโลยี TCCL</div>
                </div>
                <div class="d-flex flex-column gap-12">
                    <div class="d-flex gap-12">
                        <div style="max-width: 250px">
                            <TextField hide-details placeholder="ค้นหา" append-icon="ic:baseline-search"
                                @onChange="keyword = $event" @onEnter="getDataSearch()"></TextField>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextField from "@/components/input/TextField.vue";
import Button from '@/components/input/Button'
import { Icon } from "@iconify/vue2";

export default {
  name: 'TechnologyEvaluationEdit',
  components: {
    Icon,
    Button,
    TextField,
  },
  data() {
    return {
      keyword: "",
      data: "",
    };
  },
  created() {
    // this.getData();
  },
  methods: {
    async getData(month = null,year = null) {

      let res = await this.$apiFire("TechnologyEvaluation/index",{
        keyword: this.keyword,
      });
      if (res) {
        this.data = res.data;
      }else{
        this.data = [];
      }

      this.$nextTick(() => {
      });
    },
    routeBack() {
      this.$router.push({ name: 'TechnologyEvaluation' })
    }
  },
}
</script>

<style lang="scss" scoped></style>